import { DynamicIcon } from "lucide-react/dynamic";

interface ServiceItem {
  id: number;
  name: string;
  icon?: string;
  description?: string;
}

interface Props {
  services: ServiceItem[];
  lang?: string;
}

function isCustomIcon(icon?: string): boolean {
  if (!icon) return false;
  return (
    icon.startsWith("data:image") ||
    icon.startsWith("http://") ||
    icon.startsWith("https://")
  );
}

function resolveServiceName(name: string, lang = "it"): string {
  if (!name) return "";
  const trimmed = typeof name === "string" ? name.trim() : "";
  if (trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (typeof parsed === "object" && parsed !== null) {
        return (
          parsed[lang] ||
          parsed[lang === "en" ? "gb" : lang === "gb" ? "en" : ""] ||
          parsed["it"] ||
          Object.values(parsed)[0] ||
          name
        );
      }
    } catch {
      return name;
    }
  }
  return name;
}

export default function MinisiteServices({ services, lang = "it" }: Props) {
  if (!services.length) return null;

  return (
    <aside className="space-y-3">
      {services.map((sv) => (
        <article
          key={sv.id}
          className="min-h-24 rounded-2xl border bg-card p-4 flex items-center gap-3"
        >
          {sv.icon &&
            (isCustomIcon(sv.icon) ? (
              <img
                src={sv.icon}
                className="size-6 object-contain rounded shrink-0"
                alt="Icona servizio"
              />
            ) : (
              <DynamicIcon
                name={sv.icon as any}
                className="size-6 shrink-0 text-primary"
              />
            ))}
          <div>
            <p className="font-semibold text-card-foreground">
              {resolveServiceName(sv.name, lang)}
            </p>
            <p className="text-sm text-muted-foreground">
              Servizio in evidenza
            </p>
          </div>
        </article>
      ))}
    </aside>
  );
}
